import React, { useRef, useState, useMemo } from "react";
import { motion, useInView, AnimatePresence } from "framer-motion";
import { NavLink } from "react-router-dom";
import { Helmet } from "react-helmet";
import "./VideoGallery.css"; 

const videosData = [
  {
    youtubeId: "PwiUREaSt6g",
    category: "Testimonials",
    description: "Stablecoins in Remittance – Are they the future of cross-border payments? | MSB Association Annual Members Meet 2026",
  },
  {
    youtubeId: "TSv9xk0M6Ag",
    category: "Event",
    description: "MSB Association Annual Meet 2026 - Best Moments",
  },
  {
    youtubeId: "dL3luJheLcE",
    category: "Testimonials",
    description: "Insightful discussions on stablecoins - Mr. Giordano Cortese, First Rate Exchange Services Ltd",
  },
  {
    youtubeId: "p5ASujOCF8M",
    category: "Testimonials",
    description: "There were some really interesting discussions around stablecoins – Mr. William Brewer, Link FX",
  },
  {
    youtubeId: "0s2HhkJy-IY",
    category: "Testimonials",
    description: "The opportunity to engage with fellow stakeholders is invaluable – Mr. Thomas Onih, Director, Netsible Solutions Ltd",
  },
   {
    youtubeId: "fH3r1PNLy6I",
    category: "Testimonials",
    description: "A highly valuable platform for networking and business growth – Mr. Kamal Paudel, Director, IME London",
  },
  {
    youtubeId: "wPBiaOmqt3U",
    category: "Testimonials",
    description: "Great to be around fellow MSBs and ecosystem partners – Mr. Oliver Calma, Founder & CEO, BC Remit",
  },
 {
    youtubeId: "WSwtoIrUZvg",
    category: "Testimonials",
    description: "We got so many exchanges and I’ve learnt so many things I didn’t know before | Mr. Abdul Aden, TassaPay",
  },
  {
    youtubeId: "klF4HyX6n3s",
    category: "Testimonials",
    description: "An eye opener and a great learning experience for us all | Mrs. Bosede Adeniyi, Blessed Exchange Ltd.",
  },
   {
    youtubeId: "ynKoXbkmuxE",
    category: "Testimonials",
    description: "A really great event, and I hope to attend again next year | Ms. Teresa Cameron, CEO of Clear Junction",
  },
  {
    youtubeId: "bcJO5Ffwx8k",
    category: "Testimonials",
    description: "Happy to support and contribute to the MSB sector wherever possible | Mr. James Borley, Complyport",
  },
  {
    youtubeId: "VMvlNZVa3FQ",
    category: "Testimonials",
    description: "Very nice event, very nice people - Mr. Dima Kats founder of Clear Junction.",
  },
  
  
  
  {
    youtubeId: "WCF_Uyq2KOs",
    category: "Webinars",
    description: "HMRC Visit Preparation - Stay Compliant & Inspection Ready  by Mr. Ajinkya Patil",
  },
  {
    youtubeId: "ZURf0z5Xq1o",
    category: "Event",
    description: "Save the Date - MSB Association Annual Members Meet 2026",
  },
  
];

const categories = ["All", "Webinars", "Event", "Testimonials"];

const VideoThumbnail = ({ youtubeId, onClick, index }) => {
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, amount: 0.3 });

  const thumbnailVariants = {
    hidden: { opacity: 0, y: 50 },
    visible: { opacity: 1, y: 0 },
  };

  return (
    <motion.div
      ref={ref}
      className="col-lg-4 col-md-6 col-sm-12 mb-4 d-flex justify-content-center"
      variants={thumbnailVariants}
      initial="hidden"
      animate={isInView ? "visible" : "hidden"}
      transition={{ duration: 0.5, delay: index * 0.1 }}
      onClick={onClick}
    >
      <div className="video-thumbnail-container">
        <img
          src={`https://img.youtube.com/vi/${youtubeId}/hqdefault.jpg`}
          alt="Video thumbnail"
          className="img-fluid gallery-thumb"
        />
        <div className="play-icon">
          <i className="fa-solid fa-play"></i>
        </div>
      </div>
    </motion.div>
  );
};

const Videogallery2026 = () => {
  const [modalOpen, setModalOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [activeCategory, setActiveCategory] = useState("All");

  const filteredVideos = useMemo(() => {
    return activeCategory === "All"
      ? videosData
      : videosData.filter((v) => v.category === activeCategory);
  }, [activeCategory]);

  const openModal = (index) => {
    setCurrentIndex(index);
    setModalOpen(true);
  };

  const closeModal = () => setModalOpen(false);

  const showNext = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev + 1) % filteredVideos.length);
  };

  const showPrev = (e) => {
    e.stopPropagation();
    setCurrentIndex((prev) => (prev - 1 + filteredVideos.length) % filteredVideos.length);
  };

  const title = "Video Gallery 2026";
  const letterVariants = {
    hidden: { y: -50, opacity: 0 },
    visible: (index) => ({
      y: 0,
      opacity: 1,
      transition: { delay: index * 0.05, duration: 0.4, ease: "easeInOut" },
    }),
  };

  const gridVariants = {
    initial: { opacity: 0 },
    animate: { opacity: 1, transition: { duration: 0.5 } },
    exit: { opacity: 0, transition: { duration: 0.3 } },
  };

  return (
    <>
      <Helmet>
        <title>Video Gallery 2026 | Money Service Business Advocacy UK</title>
        <meta name="description" content="View videos from the 2026 MSB Advocacy UK event, including expert talks, networking highlights, and more." />
      </Helmet>

      <main className="page_content">
        <section className="page_header text-center section_decoration" style={{ background: "#333", position: "relative", padding: "" }}>
          <div className="container">
            <motion.h1
              className="page_title text-white"
              initial="hidden"
              animate="visible"
              style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}
            >
              {title.split("").map((letter, index) => (
                <motion.span
                  key={index}
                  custom={index}
                  variants={letterVariants}
                  style={{ display: "inline-block", whiteSpace: "pre-wrap" }}
                >
                  {letter}
                </motion.span>
              ))}
            </motion.h1>
            <ul className="breadcrumb_nav unordered_list justify-content-center">
              <li>
                <NavLink to="/">Home</NavLink>
              </li>
              <li className="active">
                <a href="#!">Video Gallery 2026</a>
              </li>
            </ul>
          </div>
        </section>

        <style jsx>{`
          .page_header {
            padding: 120px 0 60px;
          }
          @media (max-width: 768px) {
            .page_header {
              padding: 100px 0 40px;
            }
            .page_title {
              font-size: 32px !important;
              line-height: 1.2 !important;
            }
          }
          @media (max-width: 480px) {
            .page_title {
              font-size: 26px !important;
            }
          }
        `}</style>

        <section className="service_section section_space" style={{ overflow: "hidden" }}>
          <div className="container">
            {/* Category Tabs */}
            <div className="gallery_tabs_container mb-5 text-center">
              <div className="merged_tabs_pill">
                {categories.map((cat) => (
                  <button
                    key={cat}
                    className={`gallery_tab_btn ${activeCategory === cat ? "active" : ""}`}
                    onClick={() => setActiveCategory(cat)}
                  >
                    {cat}
                  </button>
                ))}
              </div>
            </div>

            <AnimatePresence mode="wait">
              <motion.div
                key={activeCategory}
                variants={gridVariants}
                initial="initial"
                animate="animate"
                exit="exit"
                className="row align-items-center mt-5 justify-content-center"
              >
                {filteredVideos.map((video, index) => (
                  <VideoThumbnail
                    key={video.youtubeId}
                    youtubeId={video.youtubeId}
                    index={index}
                    onClick={() => openModal(index)}
                  />
                ))}

                {filteredVideos.length === 0 && (
                  <div className="col-12 text-center py-5">
                    <p className="no_videos_text">No videos available in this category yet.</p>
                  </div>
                )}
              </motion.div>
            </AnimatePresence>
          </div>
        </section>

        {modalOpen && (
          <div className="modal-overlay" onClick={closeModal}>
            <div className="modal-content" onClick={(e) => e.stopPropagation()}>
              <div className="video-responsive">
                <iframe
                  width="853"
                  height="450"
                  src={`https://www.youtube.com/embed/${filteredVideos[currentIndex].youtubeId}?autoplay=1&rel=0`}
                  frameBorder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                  allowFullScreen
                  title="Embedded youtube"
                />
              </div>

              {filteredVideos[currentIndex].description && (
                <p className="modal-description">
                  {filteredVideos[currentIndex].description}
                </p>
              )}

              <button className="modal-close" onClick={closeModal}>×</button>
              <button className="modal-prev" onClick={showPrev}>❮</button>
              <button className="modal-next" onClick={showNext}>❯</button>
            </div>
          </div>
        )}
      </main>
    </>
  );
};

export default Videogallery2026;
